import React, { useState, useEffect } from 'react';
import DatePicker from 'react-datepicker';
import api from '../../../../services/api';
import { getUser } from '../../../../services/auth';
import '../../TargetReport/TableContent/index.css';
import { useMessageBox } from '../../../../context/MessageBox';
import excelIcon from '../../../../assets/images/excel48.png';
import pdfIcon from '../../../../assets/images/pdf.png';
import { toast } from 'react-toastify';
import { Grid, Button, Input, NativeSelect, Paper } from '@material-ui/core';
import * as S from './formStyle';

function OperationsMiddle({
  setTableData,
  setIsLoading,
  setTotais,
  setPermiteEdicao,
  setColaboradorId,
  reloadData,
  setReloadData,
}) {
  const classes = S.useStyles();
  const [mainDate, setMainDate] = useState(new Date());
  const [report, setReport] = useState();
  const [cpf, setCpf] = useState();
  const [colaboradores, setColaboradores] = useState([]);
  const [lastLoginId, setLastLoginId] = useState(0);
  const [status, setStatus] = useState('contratado');
  const [botaoFechar, setBotaoFechar] = useState({
    fechamentoMesBotaoTexto: '',
    fechamentoMesBotaoHabilitado: false,
  });
  const [selectedProviderLoginId, setProviderLoginId] = useState(0);

  const screenParams = {
    title: 'Relatório de Pontos',
    apiTable: 'Relatorios/Relatorio007CartaoPonto',
    apiFechamentoMes: 'Relatorios/Relatorio007CartaoPontoFechamentoMes',
    apiDownloadPdf: 'Relatorios/Relatorio007CartaoPontoDownloadPDF',
    apiDownloadExcel: 'Relatorios/Relatorio007CartaoPontoDownloadExcel',
    dateFormat: 'MM/yyyy',
  };

  const statusOptions = [
    { label: 'Pendente', value: 'Pendente', key: 0 },
    { label: 'Contratado', value: 'Contratado', key: 1 },
    { label: 'Afastado', value: 'Afastado', key: 2 },
    { label: 'Demitido', value: 'Demitido', key: 3 },
    { label: 'Reprovado', value: 'Reprovado', key: 4 },
    { label: 'Experiência', value: 'Experiencia', key: 5 },
    { label: 'Estagiário', value: 'Estagiario', key: 6 },    
  ];

  const { setMessageData } = useMessageBox();

  const fetchProviders = async (statusApi) => {
    try {
      setIsLoading(true);
      const users = await api.get(
        `Colaboradores/Consultar${statusApi !== '0' ? '?status=' + statusApi : ''}`,
      );
      setColaboradores(users.data.resposta);
    } catch (error) {
      toast.error('Não foi possível buscar colaboradores');
    } finally {
      setIsLoading(false);
    }
  };

  const fetchGridData = async (loginId) => {
    setLastLoginId(loginId || lastLoginId);

    const model = {
      mes: new Date(mainDate).getMonth() + 1,
      ano: new Date(mainDate).getFullYear(),
      loginId: loginId || lastLoginId,
      ordemDescedente: false,
      telaDePonto: false,
    };

    setReport(model);
    setIsLoading(true);

    try {
      const relatorio = await api.post(screenParams.apiTable, model);

      if (relatorio?.data?.complemento?.mensagensBox?.length > 0) {
        setMessageData(relatorio?.data?.complemento?.mensagensBox);
      }

      if (relatorio.data.status !== 'Sucesso') {
        if (relatorio.data.resposta) {
          if (relatorio.data.resposta.length > 0) {
            relatorio.data.resposta.forEach((element) => {
              toast.error(element.message);
            });
          }
        }
      } else {
        setTableData(relatorio.data.resposta.itens);
        setTotais(relatorio.data.resposta.totalizador);
        setPermiteEdicao(relatorio.data.resposta.permiteEdicao);
        setBotaoFechar({
          fechamentoMesBotaoTexto: relatorio.data.resposta.fechamentoMesBotaoTexto,
          fechamentoMesBotaoHabilitado: relatorio.data.resposta.fechamentoMesBotaoHabilitado,
        });
      }

      if (reloadData) {
        setReloadData(false);
        setLastLoginId(0);
      }
    } catch (err) {
      console.log(err);
    } finally {
      setIsLoading(false);
    }
  };

  const fecharPontoMes = async () => {
    const model = {
      mes: new Date(mainDate).getMonth() + 1,
      ano: new Date(mainDate).getFullYear(),
      loginId: lastLoginId,
      ordemDescedente: false,
      telaDePonto: false,
    };

    setIsLoading(true);

    try {
      const resposta = await api.post(screenParams.apiFechamentoMes, model);

      if (resposta?.data?.complemento?.mensagensBox?.length > 0) {
        setMessageData(resposta?.data?.complemento?.mensagensBox);
      }

      if (resposta.data.status !== 'Sucesso') {
        if (resposta.data.resposta) {
          if (resposta.data.resposta.length > 0) {
            resposta.data.resposta.forEach((element) => {
              toast.error(element.message);
            });
          }
        }
      } else {
        setBotaoFechar({
          fechamentoMesBotaoTexto: resposta.data.resposta.fechamentoMesBotaoTexto,
          fechamentoMesBotaoHabilitado: resposta.data.resposta.fechamentoMesBotaoHabilitado,
        });
        toast.success(resposta.data.status);
      }
    } catch (err) {
      console.log(err);
    } finally {
      setIsLoading(false);
    }
  };

  const exportTable = async (pdf) => {
    if (!report) return;
    setIsLoading(true);

    try {
      const url = pdf ? screenParams.apiDownloadPdf : screenParams.apiDownloadExcel;
      const relatorio = await api.post(url, report);

      if (relatorio?.data?.complemento?.mensagensBox?.length > 0) {
        setMessageData(relatorio?.data?.complemento?.mensagensBox);
      }

      if (relatorio.data.status !== 'Sucesso') {
        if (relatorio.data.resposta) {
          if (relatorio.data.resposta.length > 0) {
            relatorio.data.resposta.forEach((element) => {
              toast.error(element.message);
            });
          }
        }
        return;
      }

      const a = document.createElement('a');
      a.href =
        'data:' +
        relatorio.data.resposta.contentType +
        ';base64,' +
        relatorio.data.resposta.fileContents;
      a.download = relatorio.data.resposta.fileDownloadName;
      a.click();
      setIsLoading(false);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSelectCollaborator = async (e) => {
    if (Number(e.target.value) > 0) {
      const colaborador = colaboradores.find((item) => item.loginId === Number(e.target.value));
      setCpf(colaborador.cpf);
      setProviderLoginId(colaborador.loginId);
      setColaboradorId(colaborador.loginId);
      await fetchGridData(colaborador.loginId);
    } else {
      setCpf(null);
      setColaboradorId(0);
    }
  };

  const handleSelectStatus = async (e) => {
    setStatus(e.target.value);

    await fetchProviders(e.target.value);
    setTableData([]);
    setTotais({ horasTrabalhadas: '', sobraFalta: '' });
    setPermiteEdicao(false);
    setBotaoFechar({
      fechamentoMesBotaoTexto: '',
      fechamentoMesBotaoHabilitado: false,
    });
    setProviderLoginId(0);
    setCpf(null);
  };

  const htmlDecode = (input) => {
    const e = document.createElement('div');
    e.innerHTML = '<span>' + input + '</span>';
    return e.childNodes.length === 0 ? '' : e.childNodes[0].innerHTML;
  };

  useEffect(() => {
    const initialize = async () => {
      await fetchProviders(status);
    };
    initialize();
  }, []);

  useEffect(() => {
    const initialize = async () => {
      if ((mainDate && lastLoginId) || reloadData) {
        await fetchGridData();
      }
    };
    initialize();
  }, [mainDate, reloadData]);

  return (
    <>
      <div style={{ height: '100%' }}>
        <div className="new-body-schedule">
          <p></p>

          <div style={{ display: 'flex' }}>
            <div style={{ flex: '10 1' }}>
              <div className="schedule-input" style={{ display: 'flex', margin: '0px' }}>
                <Grid container>
                  <Grid item xs={2}>
                    <label className={classes.label}>Status</label>
                    <Paper className={classes.medium} elevation={0}>
                      <NativeSelect
                        name="status"
                        className={classes.input}
                        onChange={async (e) => await handleSelectStatus(e)}
                        value={status}
                      >
                        <option value="0">Todos</option>
                        {statusOptions.map((status) => (
                          <option key={status.key} value={status.value}>
                            {status.label}
                          </option>
                        ))}
                      </NativeSelect>
                    </Paper>
                  </Grid>
                  <Grid item xs={4}>
                    <label className={classes.label}>Colaborador</label>
                    <Paper className={classes.medium} elevation={0}>
                      <NativeSelect
                        name="colaboradorId"
                        className={classes.input}
                        onChange={async (e) => await handleSelectCollaborator(e)}
                        value={selectedProviderLoginId}
                      >
                        <option value="0">Selecione um Colaborador</option>
                        {colaboradores.map((colaborador) => (
                          <option key={colaborador.loginId} value={colaborador.loginId}>
                            {colaborador.nome}
                          </option>
                        ))}
                      </NativeSelect>
                    </Paper>
                  </Grid>
                  <Grid item xs={2}>
                    <label className={classes.label}>CPF</label>
                    <Paper className={classes.medium} elevation={0}>
                      <Input
                        style={{ textTransform: 'uppercase !important' }}
                        className={classes.input}
                        classes={{ input: classes.inputText }}
                        placeholder="CPF"
                        value={cpf || ''}
                        disabled={true}
                        inputProps={{
                          minLength: 3,
                          maxLength: 150,
                        }}
                      />
                    </Paper>
                  </Grid>
                  <Grid item xs={4}>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <div
                        className="schedule-input"
                        style={{
                          display: 'flex',
                          margin: '0px 8px',
                          flexDirection: 'column',
                          alignItems: 'center',
                        }}
                      >
                        <div style={{ marginBottom: '1rem' }}>
                          <span className={classes.label}>Mês do Ponto: </span>
                        </div>
                        <div style={{ display: 'flex' }}>
                          <Button
                            style={{
                              minWidth: '20px',
                              width: '20px',
                              height: '23px',
                              paddingLeft: '20px',
                            }}
                            onClick={() => {
                              const newDate = new Date(mainDate);
                              setMainDate(newDate.setMonth(newDate.getMonth() - 1));
                            }}
                          >
                            🢀
                          </Button>
                          <div style={{ padding: '0px 5px', maxWidth: '150px', height: '23px' }}>
                            <DatePicker
                              selected={mainDate}
                              onChange={(date) => {
                                setMainDate(date);
                              }}
                              dateFormat={screenParams.dateFormat}
                              locale="ptBR"
                            />
                          </div>
                          <Button
                            style={{ minWidth: '20px', width: '20px', height: '23px' }}
                            onClick={() => {
                              const newDate = new Date(mainDate);
                              setMainDate(newDate.setMonth(newDate.getMonth() + 1));
                            }}
                          >
                            🢂
                          </Button>
                        </div>
                      </div>
                      {botaoFechar.fechamentoMesBotaoHabilitado && (
                        <div style={{ flex: '5 1 auto' }}>
                          <Button
                            color="primary"
                            variant="contained"
                            style={{ marginRight: '10px', textTransform: 'none' }}
                            onClick={async (e) => {
                              await fecharPontoMes();
                            }}
                          >
                            <div
                              dangerouslySetInnerHTML={{
                                __html: htmlDecode(botaoFechar?.fechamentoMesBotaoTexto),
                              }}
                            />
                          </Button>
                        </div>
                      )}
                    </div>
                  </Grid>
                </Grid>
              </div>
            </div>
            <div style={{ flex: '1 1 auto', marginRight: '0px', textAlign: 'right' }}>
              <img
                src={excelIcon}
                onClick={() => {
                  exportTable(false);
                }}
                style={{ cursor: 'pointer', marginRight: '8px' }}
              ></img>
              <img
                src={pdfIcon}
                onClick={() => {
                  exportTable(true);
                }}
                style={{ cursor: 'pointer', marginBottom: '4px' }}
                width="40"
              ></img>
            </div>
          </div>

          <div></div>
        </div>
      </div>
    </>
  );
}

export default OperationsMiddle;
